import api from "./api";

export const uploadKycDocuments = (files) => {
  const fd = new FormData();
  if (files.aadhaarFront) fd.append("aadhaar_front",    files.aadhaarFront);
  if (files.aadhaarBack)  fd.append("aadhaar_back",     files.aadhaarBack);
  if (files.pan)          fd.append("pan_file",          files.pan);
  if (files.selfie)       fd.append("selfie_image",      files.selfie);
  if (files.gst)          fd.append("gst_certificate",   files.gst);
  // log for debug
  for (let [k, v] of fd.entries()) console.log("KYC fd:", k, v);
  return api.post("/kyc/documents", fd)
    .then((res) => { console.log("KYC documents response:", res.data); return res; })
    .catch((err) => {
      console.log("KYC documents full error:", err);
      console.log("KYC documents err.response?.data:", err.response?.data);
      throw err;
    });
};

export const submitKyc = (form) => {
  let dob = form.dob || "";
  if (dob && dob.includes("-")) {
    const [yyyy, mm, dd] = dob.split("-");
    dob = `${dd}/${mm}/${yyyy}`;
  }
  const payload = {
    pan_number:       form.pan,
    full_name:        form.name,
    dob,
    business_name:    form.businessName,
    business_type:    form.businessType,
    gst_number:       form.gstNumber,
    business_address: form.businessAddress,
  };
  // only send aadhaar_number if available
  payload.aadhaar_number = form.aadhaar || "verified";
  return api.post("/kyc/submit", payload);
};

export const fetchKycDocument = (field) =>
  api.get(`/kyc/document/${field}`, { responseType: "blob" });

export const getKycStatus = () =>
  api.get("/kyc/status");

export const getDigioVerificationStatus = () =>
  api.get("/kyc/digio-verification-status");

export const initiateAadhaarKyc = (customerIdentifier, dob) => {
  const fd = new FormData();
  fd.append("customer_identifier", customerIdentifier);
  if (dob) fd.append("dob", dob);
  return api.post("/kyc/verify-aadhaar/initiate", fd);
};

export const fetchAadhaarStatus = (documentId) =>
  api.get(`/kyc/verify-aadhaar/fetch/${documentId}`);
